import {Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';
import {CacheService} from '../../../cache/cache.service';
import {Observable} from 'rxjs';

export class SmdPaginationModel {
  constructor(
    public page: number,
    public size: number,
  ) {}
}

@Component({
  selector: 'smd-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SmdPaginatorComponent implements OnInit {
  private _selectedRange: number;

  currentPage: number = 1;
  numPages: number = 0;

  @Input() ranges: number[] = [10, 25, 50, 100];
  @Input() defaultRange: number = 100;

  @Input() set selectedRange(selectedRange: number) {
    let current = this._selectedRange;
    this._selectedRange = selectedRange;

    if (current != this._selectedRange) {
      this.currentPage = 1;
      this.pageChange.emit(new SmdPaginationModel(this.currentPage, this._selectedRange));
    }
  }

  get selectedRange(): number {
    if (!this._selectedRange) {
      return this.defaultRange;
    } else {
      return this._selectedRange;
    }
  }

  @Output() pageChange: EventEmitter<SmdPaginationModel> = new EventEmitter<SmdPaginationModel>();

  ngOnInit(): void {
    if (!this.selectedRange) {
      this.selectedRange = this.ranges[0];
    }
  }

  onFirstClick(event) {
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.pageChange.emit(new SmdPaginationModel(this.currentPage, this.selectedRange));
    }
  }

  onPreviousClick(event) {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.pageChange.emit(new SmdPaginationModel(this.currentPage, this.selectedRange));
    }
  }

  onNextClick(event) {
    if (this.currentPage < this.numPages) {
      this.currentPage++;
      this.pageChange.emit(new SmdPaginationModel(this.currentPage, this.selectedRange));
    }
  }

  onLastClick(event) {
    if (this.currentPage < this.numPages) {
      this.currentPage = this.numPages;
      this.pageChange.emit(new SmdPaginationModel(this.currentPage, this.selectedRange));
    }
  }

  onPageKey(event) {
    if (event.keyCode === 13) {
      this.pageChange.emit(new SmdPaginationModel(this.currentPage, this.selectedRange));
    }
  }
}
